// extracted by mini-css-extract-plugin
export default {"container":"calendarDay_container__0GtZ+","calendarSticky":"calendarDay_calendarSticky__jnLLe"};